import UserSignUp from "./components/UserSignUp";
import Installation from "./components/Installation";
import CreateQuestion from "./components/CreateQuestion";
import ArrangeSection from "./components/ArrangeSection";
import ChecklistSection from "./components/ChecklistSection";
import MeasureAdmin from "./components/MeasureAdmin";
import BasicUsage from "./components/BasicUsage";
import Props from "./components/Props";
import Events from "./components/Events";
import Styling from "./components/Styling";
import Login from "./components/Login";
import AccountHome from "./components/AccountHome";
import QuestionnaireAdmin from "./components/QuestionnaireAdmin";
import LoginAdmin from "./components/LoginAdmin";
import UserListing from "./components/UserListing";
import GroupsAdmin from "./components/GroupsAdmin";
import UpdatePassword from "./components/UpdatePassword";
import UpdateAccountInfo from "./components/UpdateAccountInfo";
import AdminUpdateAccountInfo from "./components/AdminUpdateAccountInfo";
import AdministrationHome from "./components/AdministrationHome";
import NavMenu from "./components/NavMenu";
import PostRenderTest from "./components/PostRenderTest";
import SignUp from "./components/SignUp";
import RequestAccount from "./components/RequestAccount";
import GroupSelector from "./components/GroupSelector";
import LandCertification from "./components/LandCertification";
import MetricCalculatorAGG from "./components/MetricCalculatorAGG";
import WineProduction from "./components/WineProduction";
import PerCaseMetrics from "./components/PerCaseMetrics";
import AccountRequested from "./components/AccountRequested";
import LandAccountRequested from "./components/LandAccountRequested";
import ResourceGraphs from "./components/ResourceGraphs";
import MetricsSummaryPage from "./components/MetricsSummaryPage";
import AccountRequestList from "./components/AccountRequestList";
import AccountRequestReview from "./components/AccountRequestReview";
import ComplianceQuestions from "./components/ComplianceQuestions";
import AnnualUpdate from "./components/AnnualUpdate";
import UpdateGroupInformation from "./components/UpdateGroupInformation";
import PasswordReset from "./components/PasswordReset";
import RequestPasswordReset from "./components/RequestPasswordReset";
import VueRouter from "vue-router";
import UpdateUserInfo from "./components/UpdateUserInfo";
import ResourceLinkAdmin from "@/components/ResourceLinkAdmin";
import MatrixQuestion from "@/components/vineyard/questions/VineyardQuestion";
import VineyardPage from "@/components/vineyard/VineyardPage";
import RequestVineyardAccount from "@/components/vineyard/RequestVineyardAccount";
import VineyardPageEditor from "@/components/vineyard/editor/VineyardPageEditor";
import VineyardAccountRequestReview from "@/components/vineyard/admin/VineyardAccountRequestReview";
import SentAlerts from "@/components/SentAlerts";
import CreateUser from "@/components/vineyard/admin/CreateUser";
import UpdateUser from "@/components/vineyard/admin/UpdateUser";
import CreateParentCompany from "@/components/admin/CreateParentCompany";
import ParentCompanyAdmin from "@/components/admin/ParentCompanyAdmin";
import UpdateParentCompany from "@/components/admin/UpdateParentCompany";
import DocumentUploads from "@/components/vineyard/upload/DocumentUploads";
import DocumentCommentsUploads from "@/components/vineyard/upload/DocumentCommentsUploads";
import VineyardResourceGraphs from "@/components/vineyard/metrics/graph/VineyardResourceGraphs";
import MenuEditor from "@/components/vineyard/editor/MenuEditor.vue";
import MigrationController from "@/components/migration/MigrationController.vue";
import MetricsCalculatorSingle from "@/components/MetricsCalculatorSingle.vue";
import NotificationEditor from "@/components/admin/NotificationEditor.vue";
import CreatePage from "@/components/vineyard/editor/CreatePage.vue";
import UpcomingAlertView from "@/components/admin/UpcomingAlertView.vue";
import HelpViewPage from "@/components/help/HelpViewPage";
import HelpPopupPage from "@/components/help/HelpPopupPage";


function beforeRouteEnter(to, from, next) {
    if (isAdminUser()) {
        next();
    } else {
        next(false);
    }
}

function isAdminUser() {
    return localStorage.getItem('roles').includes('admin')
        || localStorage.getItem('roles').includes('VINEYARD_ADMIN');
}

let routes = {
//    mode: "history",

    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/survey',
            name: 'SurveyLink',
            component: VineyardPage,
            props: true,
            meta: {
                auth: true,
                title: 'Checklist'
            }
        },
        {
            path: '/sign-up',
            name: 'Sign Up',
            component: UserSignUp
        },
        {
            path: '/installation',
            name: 'Installation',
            component: Installation
        },
        {
            path: '/question',
            name: 'Question',
            component: CreateQuestion
        },
        {
            path: '/arrange-section',
            name: 'Arrange Section',
            component: ArrangeSection
        },
        {
            path: '/edit-checklist',
            name: 'Edit Checklist',
            component: ChecklistSection
        },
        {
            path: '/measures',
            name: 'View Measures',
            component: MeasureAdmin
        },
        {
            path: '/basic-usage',
            name: 'BasicUsage',
            component: BasicUsage
        },
        {
            path: '/props',
            name: 'Props',
            component: Props
        },
        {
            path: '/events',
            name: 'Events',
            component: Events
        },
        {
            path: '/styling',
            name: 'Styling',
            component: Styling
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/my-account',
            name: 'My Account',
            component: AccountHome
        },
        {
            path: '/questionnaire-admin',
            name: 'Questionnaire Admin',
            component: QuestionnaireAdmin
        },
        {
            path: '/login-admin',
            name: 'Login Admin',
            component: LoginAdmin
        },
        {
            path: '/users',
            name: 'User Listing',
            component: UserListing
        },
        {
            path: '/groups',
            name: 'My Team',
            component: GroupsAdmin
        },
        {
            path: '/update-password',
            name: 'Update Password',
            component: UpdatePassword
        },
        {
            path: '/update-account-info',
            name: 'Update_Account',
            component: UpdateAccountInfo,
            props: true
        },
        {
            path: '/admin-update-account-info',
            name: 'AdminUpdateAccount',
            component: AdminUpdateAccountInfo,
            props: true
        },
        {
            path: '/user-info',
            name: 'Update_User',
            component: UpdateUserInfo,
            props: true
        },
        {
            path: '/administration',
            name: 'Administration Home',
            component: AdministrationHome,
            beforeEnter: beforeRouteEnter
        },
        {
            path: '/nav',
            name: 'Nav Menu',
            component: NavMenu
        },
        {
            path: '/test',
            name: 'Test',
            component: PostRenderTest
        },
        {
            path: '/landing',
            name: 'Sign Me Up',
            component: SignUp
        },
        {
            path: '/request-account-from-me',
            name: 'LandingPage',
            component: RequestAccount
        },
        {
            path: '/request-winery-account',
            name: 'LandingPage',
            component: RequestAccount
        },
        {
            path: '/group-selector',
            name: 'GroupSelector',
            component: GroupSelector
        },
        {
            path: '/request-land-certification',
            name: 'LandCertificationRequest',
            component: LandCertification
        },
        {
            path: '/metrics-calculator',
            name: 'Calculator',
            component: MetricCalculatorAGG
        },
        {
            path: '/metrics-tabbed',
            name: 'TabbedMetrics',
            component: MetricsCalculatorSingle,
            props: true
        },
        {
            path: '/metrics-single',
            name: 'SingleMetric',
            component: MetricsCalculatorSingle,
            props: true
        },
        {
            path: '/edit/notification',
            name: 'NotificationEditor',
            component: NotificationEditor,
            props: true
        },
        {
            path: '/bottles-metric',
            name: 'Bottles',
            component: WineProduction
        },
        {
            path: '/per-case-metrics',
            name: 'PerCaseMetrics',
            component: PerCaseMetrics
        },
        {
            path: '/account-requested',
            name: 'AccountRequested',
            component: AccountRequested
        },
        {
            path: '/land-account-requested',
            name: 'LandAccountRequested',
            component: LandAccountRequested
        },
        {
            path: '/resource-graphs',
            name: 'Resource Graphs',
            component: ResourceGraphs,
            props: true
        },
        {
            path: '/metrics-summary',
            name: 'Metrics Summary',
            component: MetricsSummaryPage,
            props: true
        },
        {
            path: '/review-requests',
            name: 'Account Requests',
            component: AccountRequestList,
            props: true
        },
        {
            path: '/review-request',
            name: 'Account Request Review',
            component: AccountRequestReview,
            props: true
        },
        {
            path: '/compliance',
            name: 'Compliance Review',
            component: ComplianceQuestions,
            props: true
        },
        {
            path: '/annual-update',
            name: 'Annual Update',
            component: AnnualUpdate,
            props: true
        },
        {
            path: '/documentation',
            name: 'Documentation',
            component: DocumentUploads,
            props: true
        },
        {
            path: '/comments',
            name: 'Comments',
            component: DocumentCommentsUploads,
            props: true
        },
        {
            path: '/group-info-update',
            name: 'Group Update',
            component: UpdateGroupInformation,
            props: true
        },
        {
            path: '/password-reset',
            name: 'Password Reset',
            component: PasswordReset,
            props: true
        },
        {
            path: '/forgot-password',
            name: 'Request Password Reset',
            component: RequestPasswordReset,
            props: true
        },
        {
            path: '/external-resources',
            name: 'Configure External Links',
            component: ResourceLinkAdmin,
            props: true
        },
        {
            path: '/matrix',
            name: 'Matrix Question',
            component: MatrixQuestion,
            props: true
        },
        {
            path: '/vineyard-page',
            name: 'Vineyard Page',
            component: VineyardPage,
            props: true
        },
        {
            path: '/vineyard-editor',
            name: 'Vineyard Page Editor',
            component: VineyardPageEditor,
            props: true
        },
        {
            path: '/request-vineyard-account',
            name: 'VineyardAccountRequest',
            component: RequestVineyardAccount
        },
        {
            path: '/review-vineyard-request',
            name: 'Vineyard Account Request Review',
            component: VineyardAccountRequestReview,
            props: true
        },
        {
            path: '/vineyard-resource-graphs',
            name: 'Vineyard Resource Graphs',
            component: VineyardResourceGraphs,
            props: true
        },
        {
            path: '/alerts-sent',
            name: 'Alerts Sent',
            component: SentAlerts,
            props: true
        },
        {
            path: '/create-question',
            name: 'Create Question',
            component: CreateQuestion,
            props: true
        },
        {
            path: '/create-user',
            name: 'Create User',
            component: CreateUser,
            props: true
        },
        {
            path: '/update-user',
            name: 'Update User',
            component: UpdateUser,
            props: true
        },
        {
            path: '/create/parent-company',
            name: 'Create Parent Company',
            beforeEnter: beforeRouteEnter,
            component: CreateParentCompany,
            props: true
        },
        {
            path: '/parent-company',
            name: 'View Parent Companies',
            beforeEnter: beforeRouteEnter,
            component: ParentCompanyAdmin,
            props: true
        },
        {
            path: '/parent-company/:id',
            name: 'Update Parent Company',
            beforeEnter: beforeRouteEnter,
            component: UpdateParentCompany,
            props: true
        },
        {
            path: '/menu',
            name: 'Menu',
            component: MenuEditor,
            props: true
        },
        {
            path: '/page',
            name: 'Page',
            component: CreatePage,
            props: true
        },
        {
            path: '/migration',
            name: 'Migration',
            component: MigrationController,
            props: true
        },
        {
            path: '/upcoming-alerts',
            name: 'Upcoming Alerts',
            component: UpcomingAlertView,
            props: true
        },
        {
            path: '/help/:key',
            name: 'HelpView',
            component: HelpViewPage
        },
        {
            path: '/help-popup/:key',
            name: 'HelpPopup',
            component: HelpPopupPage,
            meta: { popup: true }
        },
        {
            path: '*',
            component: AccountHome
        }
    ]
};
const router = new VueRouter(routes);

function getTokenExpiration() {
    let expDate = new Date(1970, 1, 1);
    let expirationSeconds = localStorage.getItem("tokenExpiration");
    if (localStorage.getItem('user') !== null && expirationSeconds !== null) {
        expDate.setSeconds(Number.parseInt(expirationSeconds));
    }
    return expDate;
}

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login', '/request-account-from-me', '/request-land-certification', "/request-vineyard-account"
        , "/request-winery-account", "/account-requested", "/land-account-requested", "/password-reset", "/forgot-password"];
    const authRequired = !publicPages.includes(to.path);
    let expDate = getTokenExpiration();
    const loggedIn = (localStorage.getItem('user') !== null) && (Date.now() < expDate);
    if (to.path === '/login') {
        //console.log("Go to Login Page");
    } else {
        if (authRequired && !loggedIn) {
            return next({
                path: '/login',
                query: {returnUrl: to.path}
            });
        }
    }
    document.title = to.meta.title || 'NapaGreen.org';
    next();
});

router.afterEach((to) => {
    if (to.path && !to.path.startsWith('/help')) {
        import('./store').then(({ default: store }) => {
            store.dispatch('help/prefetchPage', to.path.replace(/^\//, ''));
        });
    }
});

export default router
